import React from "react";
import OrderMain from "../Order";

const NewOrder = () => {
  return <OrderMain module="new-order" title="New Order" />;
};

export default NewOrder;
